var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSetupOnly = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.26 19h-1.85a.75.75 0 0 1 0-1.5h1.85a.75.75 0 1 1 0 1.5m-6.64 0H.75a.75.75 0 1 1 0-1.5h12.87a.75.75 0 1 1 0 1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 21.41a3.15 3.15 0 1 1-.02-6.3 3.15 3.15 0 0 1 .02 6.3m0-4.79a1.65 1.65 0 1 0-.02 3.3 1.65 1.65 0 0 0 .02-3.3M11.58 19H7.36a.75.75 0 0 1-.75-.75V9.46a.75.75 0 0 1 .75-.75h4.22a.74.74 0 0 1 .75.75v8.8a.74.74 0 0 1-.75.74m-3.47-1.5h2.72v-7.3H8.11zM20.27 19a.74.74 0 0 1-.75-.75V9.46a.75.75 0 1 1 1.5 0v8.8a.75.75 0 0 1-.75.74"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.25 10.21H4a.75.75 0 0 1-.67-.4L.09 3.69A.71.71 0 0 1 .11 3a.74.74 0 0 1 .64-.37H20a.74.74 0 0 1 .66.4l3.28 6.12a.71.71 0 0 1 0 .73.74.74 0 0 1-.69.33M4.47 8.71H22l-2.48-4.62H2z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgSetupOnly;